import type {GridMediaItemStorage, GridMediaItemTag} from '@Components/base-grid/components/grid-media-item';
import {GridMediaItem} from '@Components/base-grid/components/grid-media-item';
import {GridItemTag} from '@Components/base-grid/components/grid-item-tag/grid-item-tag';
import type {GridItemProps} from '@Components/base-grid/components/grid-item';
import type {ReactElement} from 'react';
import {useState} from 'react';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import styles from './grid-extracted-getty-sticker-item.module.scss';

export interface GridExtractedGettyStickerItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
  width?: number;
  height?: number;
}

interface GridExtractedGettyStickerItemProps extends GridItemProps {
  thumbSrc: string;
  tag?: GridMediaItemTag;
}

export function GridExtractedGettyStickerItem({...props}: GridExtractedGettyStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <>
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
              void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
            }}
            src={props.thumbSrc}
            className={styles.thumb}
            alt={window.i18next.t('pmwjs_sticker')}
            draggable="false"
            loading="lazy"
          />
          <GridItemTag tag={props.tag} />
        </>
      }
    />
  );
}
